import Alert from './code/Scripts/components/alert.vue';

export default {
  components: {
    Alert,
  },
};
